module.exports = __webpack_public_path__ + "media/images/sf-brand-61e1d7c5b06a5d3c2ca56630da1a5029.png";